import { render, staticRenderFns } from "./SecaoVazia.vue?vue&type=template&id=7a66d453&scoped=true&"
import script from "./SecaoVazia.vue?vue&type=script&lang=js&"
export * from "./SecaoVazia.vue?vue&type=script&lang=js&"
import style0 from "./SecaoVazia.vue?vue&type=style&index=0&id=7a66d453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a66d453",
  null
  
)

export default component.exports